import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

/**
 * Resolves the source ID for a calendar event.
 * This creates a deterministic UUID based on the connected calendar event ID.
 */
export const resolveSourceIdForCalendarEvent = ({
  connectedCalendarEventId,
}: {
  connectedCalendarEventId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.Source },
    uuids: [connectedCalendarEventId],
  });
};
